module.exports = __webpack_public_path__ + "img/la.38d5a90f.jpg";